<template>
    <div class="flex relative my-auto container mx-auto">

      <PrevArrow prev="sub-offer-five"/>

      <div class="subsection-big-circle bg-black rounded-full mx-auto">
        <h1 class="text-white mx-auto pt-8 text-2xl font-bold">PERFECT <br>FOR LOBBYING</h1>
        <p class="text-teal mt-8 text-4xl font-bold leading-tight">POSITIVE EFFECTS <br>FOR THE PEOPLE, <br>CULTURE AND <br>SOCIETY: HAPPINESS, <br>HUMANITY AND <br>BETTER <br>DEMOCRACY</p>
      </div>

      <NextArrow next="deep-info-main-menu"/>

    </div>
</template>

<script>
import PrevArrow from "@/components/deepinfo/subnavigation/PrevArrow.vue";
import NextArrow from "@/components/deepinfo/subnavigation/NextArrow.vue";

export default {
  name: "OfferSubSix",
  components:{
    PrevArrow,
    NextArrow
  }
}
</script>
